import { RouteConfig } from 'vue-router'

const Layout = () => import('../views/Layout.vue')
const Edit = () => import('../views/UserEdit.vue')

export const editRoute: RouteConfig = {
  path: 'edit',
  name: 'user_edit',
  component: Edit,
  meta: { title: '个人信息', showMenu: false },
}

export default [
  {
    path: '/user',
    name: 'user',
    component: Layout,
    meta: { title: '教学资源中心', showMenu: false },
    children: [editRoute],
  },
]
